import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App.jsx";
import { LocaleProvider } from "./i18n.jsx";
import { PlusProvider } from "./plus/PlusProvider.jsx";
import "./styles.css";

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <LocaleProvider>
      <PlusProvider>
        <App />
      </PlusProvider>
    </LocaleProvider>
  </React.StrictMode>
);
